import React from "react";
import { Route, Routes } from "react-router-dom";
import Login from "./containers/Login";
import LoginOld from "./containers/LoginOld";
import ForgotPassword from "./containers/ForgotPassword";
import ChangePassword from "./containers/ChangePassword";

export default ({ childProps }) => {

  return (

    <Routes>
      <Route
        path="/login"
        element={
          <Login {...childProps} />
        }
      />
      <Route path="/loginold" exact render={(props) => (
        <LoginOld {...props} props={childProps} />
      )} />        
      <Route
        path="/forgot/pwd"
        element={
          <ForgotPassword {...childProps}/>
        }
      />
      <Route
        path="/change/pwd"
        element={
          <ChangePassword {...childProps}/>
        }
      />
      { /* Finally, catch all unmatched routes */}
      <Route
        path="/*"
        element={
          <Login {...childProps} />
        }
      />
    </Routes>)
};
